import { MenuIcon } from '@heroicons/react/outline';

interface AppHeaderProps {
  onMenuClick: () => void;
}

const AppHeader = ({ onMenuClick }: AppHeaderProps) => {
  return (
    <header className=" bg-gray-50 top-0 z-10 px-5 py-6 ">
      {/* <div className="flex justify-between items-center h-12">
        <div className="flex items-center">
          <div className="h-8 w-10 rounded-lg bg-blue-500 flex items-center justify-center">
            <span className="text-white font-bold">LexP</span>
          </div>
        </div>
        <button
          type="button"
          className="p-2 rounded-full text-gray-500 hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          onClick={onMenuClick}
        >
          <span className="sr-only">Open sidebar</span>
          <MenuIcon className="h-6 w-6" aria-hidden="true" />
        </button>
      </div> */}
    </header>
  );
};

export default AppHeader;
